import { SimpleArticleInterfaceType } from './articleInterface';
import { ProductOrderingModeEnumApi } from 'graphql/generated';
import { ListedBrandType, SimpleBrandType } from 'types/brand';
import { ListedCategoryType, SimpleCategoryConnectionType } from 'types/category';
import { AutocompleteProductConnectionType, ListedProductConnectionPreviewType } from 'types/product';

export type AutocompleteSearchType = {
    articlesSearch: SimpleArticleInterfaceType[];
    brandSearch: SimpleBrandType[];
    categoriesSearch: SimpleCategoryConnectionType;
    productsSearch: AutocompleteProductConnectionType;
};

export type SearchType = {
    articlesSearch: SimpleArticleInterfaceType[];
    brandSearch: ListedBrandType[];
    productsSearch: ListedProductConnectionPreviewType;
    categoriesSearch: {
        totalCount: number;
        categories: ListedCategoryType[];
    };
};

export const EMPTY_SEARCH_RESULT: SearchType = {
    articlesSearch: [],
    brandSearch: [],
    productsSearch: {
        productFilterOptions: {
            brands: null,
            flags: null,
            inStock: 0,
            maximalPrice: '0.0',
            minimalPrice: '0.0',
            parameters: null,
            __typename: 'ProductFilterOptions',
        },
        orderingMode: ProductOrderingModeEnumApi.RelevanceApi,
        defaultOrderingMode: null,
        totalCount: 0,
    },
    categoriesSearch: {
        totalCount: 0,
        categories: [],
    },
};
